import React from 'react'
import PropTypes from 'prop-types'

import Timer from 'components/Timer/Timer'

import styles from './ReserveActivationTimer.scss'

export default class ReserveActivationTimer extends React.Component {
    static propTypes = {
        endTime: PropTypes.object,
    }
    render() {
        if (!this.props.endTime) return null

        return (
            <div className={styles.base}>
                <p className={styles.time}>
                    <Timer endTime={this.props.endTime} />
                </p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/Stronghold/components/ReserveActivationTimer/ReserveActivationTimer.jsx